"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const setDataDbDirect = ({ isDevelopment }) => async ({ entryVars: { path, data, shouldUpdateDbCache = false, }, functionId, callbacks, executeProcesses, processor, }) => {
    const { updateRenderDBCache, databaseCore } = processor.root;
    if (data === undefined || typeof path !== 'string') {
        executeProcesses(undefined, callbacks.onNoData);
        return;
    }
    const listener = (result) => {
        if (result) {
            executeProcesses(functionId, callbacks.success, data);
            return;
        }
        executeProcesses(undefined, callbacks.error);
    };
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        executeProcesses(functionId, callbacks.error, (0, getErrorMessageNoProjectIdFoundInApp_1.default)('setDataDbDirect'));
        return;
    }
    if (databaseCore && (databaseCore === null || databaseCore === void 0 ? void 0 : databaseCore.write)) {
        databaseCore.write({
            updates: {
                [path]: data,
            },
            shouldUpdateDbCache: !!shouldUpdateDbCache,
            projectId,
            listener,
            setRenderDbCache: updateRenderDBCache,
            isDevelopment,
        });
    }
};
exports.default = setDataDbDirect;
